exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._26qaKQzZotyFAOhTC-yE8o{width:300px}html[dir=ltr] ._26qaKQzZotyFAOhTC-yE8o{margin:8px 0 8px 26px}html[dir=rtl] ._26qaKQzZotyFAOhTC-yE8o{margin:8px 26px 8px 0}html[dir] ._3dzF1yakDribE5EkzMWvOg{margin:4px 0 16px}html[dir=ltr] ._3cf1LLPmjChfiT363HLMQW{padding-left:0}html[dir=rtl] ._3cf1LLPmjChfiT363HLMQW{padding-right:0}", ""]);

// exports
exports.locals = {
	"formContainer": "_26qaKQzZotyFAOhTC-yE8o",
	"emailInput": "_3dzF1yakDribE5EkzMWvOg",
	"label": "_3cf1LLPmjChfiT363HLMQW"
};